import convertInchToPx from './convertInchToPx.js';
import convertPtToInch from './convertPtToInch.js';

/**
 * Converts PostScript points to pixels.
 * @param {number} pt
 * @param {number} customDPI
 * @returns {number}
 */
const convertPtToPx = (pt, customDPI) => {
  const inch = convertPtToInch(pt);
  return convertInchToPx(inch, customDPI);
};

export default convertPtToPx;
